import Base from "../Step.es6";

// Change color of label
export default class extends Base {
    constructor(Configurator) {
        super('color', Configurator.mode.DESIGN_USER, Configurator);
        this.level      = Configurator.PURCHASE_LEVEL_HIGH;
        const defaultValues = {
            cmyk:   null,
            hex:    null,
        };
        this.values = {
            color:      false,
            opacity:    100,
            primary:    defaultValues,
            secondary:  defaultValues,
        };
    }
    get url() {
        const Configurator = this.Configurator;
        const text = Configurator.Progress.get('text').values;
        const query = {
            image:  this.Configurator.Progress.get('edit').values.url,
            id:     this.Configurator.id,
        };
        if (this.values.color)  query['selected']       = this.values.color;
        if (text.name)          query['name']           = text.name;
        if (text.description)   query['description']    = text.description;
        return 'color?' + URI.buildQuery(query);
    }
    required() {
        return ['upload', 'edit'];
    }
    validate() {
        return (this.values.color) || (this.values.primary && this.values.secondary);
    }
    commit(values) {
        for (let key in values) this.values[key] = values[key];
        this.Configurator.Progress.get('create').remove();
        return this;
    }
    remove() {
        this.ready = false;
        return this;
    }
    run() {
        return this;
    }
}
